/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-undef */
import '../App.css';
import React, { useEffect, useRef, useMemo, useState } from 'react';
import twitter from '../assets/twitter-.png';
import facebook from '../assets/facebook.png';
import instagram from '../assets/instagram.png';
import whatsapp from '../assets/whatsapp.png';
import navbar from '../assets/navigation-bar.png';
import wrong from '../assets/wrong.png';
import logoPic from '../assets/logo.jpg';
import ticket from '../assets/movie.png';
import ticketR from '../assets/ticketR.png';
import money from '../assets/money.png';
import Footer from '../components/footer';
import line3 from '../assets/line3.jpg';
import money2 from '../assets/1710350929.jpeg';
import user from '../assets/profile-user.png';
import calander from '../assets/calendar.png';
import coin from '../assets/coin.png';

import $ from 'jquery';
import { Web3Button, Web3Modal, useWeb3Modal } from '@web3modal/react';
import { mainnet, useAccount, useContractRead, useContractReads, useContractWrite, useNetwork, usePublicClient, useSwitchNetwork, useDisconnect } from 'wagmi';
import { createPublicClient, formatEther, http, parseEther } from 'viem';
import { pulsechainV4 } from 'wagmi/chains';
import { useNavigate } from 'react-router-dom';

import contractRaffle from '../contractData/contractRaffle.json';
import contractToken from '../contractData/contractToken.json';


var Scroll = require('react-scroll');

$(window).on('load', function () {
  setTimeout(function () { // allowing 3 secs to fade out loader
    $('.page-loader').fadeOut('slow');
  }, 2000);
});

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  /*	if (completed) {
          // Render a completed state
          return <Completionist />;
      } else {*/
  // Render a countdowns

  if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {

    window.location.reload(true);
    console.log("Mint Begins");
  }


  return <div class="counterBlock"><div class="days">{days}</div><div class="dots">:</div><div class="days">{hours}</div><div class="dots">:</div><div class="days">{minutes}</div><div class="dots">:</div><div class="sec">{seconds}</div></div>;
  /*	}*/
};

let signer;
var Link = Scroll.Link;
var DirectLink = Scroll.DirectLink;
var Element = Scroll.Element;
var Events = Scroll.Events;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;


const tweet = () => {
  window.open("#");
}

const discord = () => {
  window.open("#");
}

const os = () => {
  window.open("#");
}
const address = contractRaffle.address;
const ABI = contractRaffle.abi;

const addressToken = contractToken.address;
const ABIToken = contractToken.abi;

const MyInvestment = () => {

  const { open } = useWeb3Modal()
  const { chain } = useNetwork()
  const { switchNetwork } = useSwitchNetwork()
  const navigate = useNavigate();

  const { address: walletAddress } = useAccount({
    async onConnect() {
      handleConnect()
    }
  })

  const publicClient = createPublicClient({
    chain: pulsechainV4,
    transport: http()
  })

  const [_totalSupply, settotalSupply] = useState(0)
  const [statusError, setstatusError] = useState("")
  const [statusLoading, setstatusLoading] = useState("")
  const [success, setsuccess] = useState("")
  const [nftMintingAmount, setnftMintingAmount] = useState(1)
  const [_publicMintMsg, set_publicMintMsg] = useState("Mint Here")
  const [_cost, set_publicSaleCost] = useState("")
  const [_wlcost, set_wlcost] = useState("")
  const [_max_per_wallet, set_max_per_wallet] = useState(10)
  const [_owner, set_owner] = useState("")
  const [myNFTWallet, setmyNFTWallet] = useState(0)
  const [_whitelist_mint_status, set_whitelist_mint_status] = useState("")
  const [_public_mint_status, set_public_mint_status] = useState("")
  const [_whitelistLimitPerWallet, set_whitelistLimitPerWallet] = useState("")
  const [_whitelistCount, set_whitelistCount] = useState("")
  const [_whitelistLimit, set_whitelistLimit] = useState("")
  const [_MAX_SUPPLY, set_MAX_SUPPLY] = useState("")
  const [_navbarOpen, set_navbarOpen] = useState(0)
  const [_RafflesList, setRafflesList] = useState(0)
  const [_TotalRaffles, setTotalRaffles] = useState(0)
  const [_connected, setConnected] = useState(false)
  const [raffles, setRaffles] = useState([]);
  const [expectedValues, setExpectedValues] = useState({});
  const [ticketIndex, setTicketIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rafflesPerPage = 15;
  const [filter, setFilter] = useState('ongoing'); // 'all', 'ongoing', 'ended'
  const indexOfLastRaffle = currentPage * rafflesPerPage;
  const indexOfFirstRaffle = indexOfLastRaffle - rafflesPerPage;

  const [purchasedRaffles, setPurchasedRaffles] = useState([]);
  const [isLoadingPurchased, setIsLoadingPurchased] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setShowDropdown(!showDropdown);
  }

  const filteredRaffles = useMemo(() => {
    if (!raffles.length) return [];

    return raffles.filter(raffle => {
      const now = Date.now() / 1000; // Current time in seconds
      const isEnded = raffle.endTime < now; // Check if endTime has passed

      if (filter === 'all') return true;
      if (filter === 'ongoing') return !isEnded;
      if (filter === 'ended') return isEnded;
      return true;
    });
  }, [raffles, filter]);

  // Update pagination to use filteredRaffles
  const currentRaffles = filteredRaffles.slice(indexOfFirstRaffle, indexOfLastRaffle);
  const totalPages = Math.ceil(filteredRaffles.length / rafflesPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  const { disconnect } = useDisconnect();

  async function closeNav() {
    set_navbarOpen(0);
  }

  async function navbarOpen() {
    set_navbarOpen(1);
  }

  //........................................//
  const contract = {
    address: address,
    abi: ABI
  }

  const contracToken = {
    address: addressToken,
    abi: ABIToken
  }

  async function handleConnect() {
    if (chain.id !== 943) {
      switchNetwork(943)
    }

    setConnected(true);
  }

  /*const { refetch: getRafflesList } = useContractRead({
      ...contract,
      functionName: 'raffles', 
  })*/


  /*useEffect(() => {

      async function fetchTotalRaffles() {
          var data = await getTotalRaffles();

          setTotalRaffles(Number(data.data))
          console.log("TotalRaffles : " + data.data)
      }

      async function fetchRafflesList() {
          var data = await getRafflesList();

          setRafflesList(Number(data.data))
          console.log("RafflesList : " + data.data)
      }

      fetchTotalRaffles();
      fetchRafflesList();

      // eslint-disable-next-line no-use-before-define
  }, [_connected]);*/

  const { refetch: getExpectedTotalValue } = useContractRead({
    ...contract,
    functionName: 'expectedTotalValue',
    args: []
  })

  // ✅ Fetch total number of raffles
  const { data: totalRaffles, isError: totalError } = useContractRead({
    address: address,
    abi: ABI,
    functionName: "totalRaffles",
  });

  console.log("Total Raffles:", totalRaffles, "Error:", totalError);

  // ✅ Fetch all raffles and their images
  const { data: raffleData, isLoading, isError } = useContractReads({
    contracts: totalRaffles
      ? Array.from({ length: Number(totalRaffles) }, (_, i) => ([
        {
          address: address,
          abi: ABI,
          functionName: "raffles",
          args: [i + 1], // Fetch raffle details
        },
        {
          address: address,
          abi: ABI,
          functionName: "image",
          args: [i + 1], // Fetch raffle image
        }
      ])).flat() // Flatten array to avoid nesting
      : [],
  });

  console.log("Fetched Raffle Data:", raffleData, "Error:", isError);

  useEffect(() => {
    if (raffleData) {
      const formattedRaffles = [];

      for (let i = 0; i < raffleData.length; i += 2) {
        const raffle = raffleData[i].result;
        const image = raffleData[i + 1].result; // Fetch corresponding image

        if (raffle && image) {
          formattedRaffles.push({
            id: raffle[0].toString(),
            creator: raffle[1],
            name: raffle[2],
            tagline: raffle[3],
            endTime: Number(raffle[5]),
            ticketPrice: raffle[11].toString(),
            imageUrl: image, // Add image to the object
            totalTicketsIssued: Number(raffle[7]), // Add image to the object
            totalValue: raffle[8].toString(),
          });
        }
      }

      setRaffles(formattedRaffles);

      console.log("formattedRaffles : " + JSON.stringify(formattedRaffles));
    }

  }, [raffleData]);

  const { writeAsync } = useContractWrite({
    ...contract,
    functionName: 'mint',
    onError(error) {
      if (error.message.includes('balance')) {
        setstatusError(true)
        setstatusLoading(false)
      }
    }
  })

  async function disconnectWallet() {
    setConnected(false);
    disconnect();
    //window.location.reload(true);
  }

  async function stateMerge() {

  }

  function shortenAddress(walletAddress) {
    try {
      return _connected
        ? walletAddress.slice(0, 3) + "..." + walletAddress.slice(-4)
        : "Connect";
    } catch (error) {
      console.log(error);
    }
  }

  const fetchExpectedValues = async () => {
    const values = {};
    for (let raffle of raffles) {
      try {
        const value = await publicClient.readContract({
          address: address,
          abi: ABI,
          functionName: 'expectedTotalValue',
          args: [raffle.id] // use raffle.id here
        });
        values[raffle.id] = value.toString();
      } catch (err) {
        console.error("Error fetching expected value:", err);
      }
    }
    setExpectedValues(values);
    console.log("expectedValues : " + JSON.stringify(expectedValues));
  };

  useEffect(() => {
    if (raffles.length > 0) {
      fetchExpectedValues();
    }
  }, [raffles]); // 👈 re-run when `raffles` change


  const fetchPurchasedRaffles = async () => {
    if (!walletAddress) return;

    setIsLoadingPurchased(true);
    try {
      // Option 1: Using getUserTicketSummary (simpler data)
      const [raffleIds, ticketCounts, totalValues] = await publicClient.readContract({
        address: address,
        abi: ABI,
        functionName: 'getUserTicketSummary',
        args: [walletAddress]
      });

      // Option 2: Using getUserRaffleActivities (more detailed data)
      const activities = await publicClient.readContract({
        address: address,
        abi: ABI,
        functionName: 'getUserRaffleActivities',
        args: [walletAddress]
      });

      // Get full raffle details for each purchased raffle
      const purchasedDetails = await Promise.all(
        activities.map(async (activity) => {
          const raffle = await publicClient.readContract({
            address: address,
            abi: ABI,
            functionName: 'raffles',
            args: [activity.raffleId]
          });

          const imageUrl = await publicClient.readContract({
            address: address,
            abi: ABI,
            functionName: 'image',
            args: [activity.raffleId]
          });

          return {
            id: activity.raffleId,
            creator: raffle[1],
            name: raffle[2],
            tagline: raffle[3],
            endTime: Number(raffle[5]),
            ticketPrice: raffle[11].toString(),
            imageUrl: imageUrl,
            totalTicketsIssued: Number(raffle[7]),
            totalValue: raffle[8].toString(),
            // Add activity details
            ticketsPurchased: activity.ticketCount,
            totalSpent: activity.totalSpent,
            isRefunded: activity.isRefunded,
            isWinner: activity.isWinner
          };
        })
      );

      setPurchasedRaffles(purchasedDetails);
    } catch (error) {
      console.error("Error fetching purchased raffles:", error);
    } finally {
      setIsLoadingPurchased(false);
    }
  };

  useEffect(() => {
    if (walletAddress) {
      fetchPurchasedRaffles();
    }
  }, [walletAddress]);

  return (
    <div class="allWrap">
      <div class="light">

        {_navbarOpen < 1 ?
          (<div class="miniBarMain">
            <img className='logoPic' onClick={() => window.location.href = '/'} src={logoPic} />

            <div className='loginDiv'><button className='login'>Connect</button><img class="navbar" onClick={navbarOpen} src={navbar} /></div>
          </div>) :
          (<div class="miniBarMain">
            <img className='logoPic' onClick={() => window.location.href = '/'} src={logoPic} />

            <div className='loginDiv'><button className='login'>Connect</button><img class="navbar" onClick={closeNav} src={wrong} /></div>

          </div>)}

        <div class="headers">

          <div class="h1">

            <div class="connect">
              <div ><Link activeClass="" id="fontSize" onClick={() => window.location.href = 'raffles'}>Raffles</Link></div>
              <div className="dropdown-wrapper" ref={dropdownRef}>
                <Link
                  className="nav-link with-dropdown"
                  onClick={toggleDropdown}
                >
                  <span id="fontSize" className={showDropdown ? 'active' : ''}>My Raffles</span>
                  <svg
                    className={`dropdown-icon ${showDropdown ? 'rotate' : ''}`}
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                  >
                    <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </Link>

                {showDropdown && (
                  <div className="dropdown-menu">
                    <Link
                      className="dropdown-item"
                      onClick={() => window.location.href = 'my-raffles'}
                    >
                      Created Raffles
                    </Link>
                    <Link
                      className="dropdown-item"

                    >
                      <span className='active'>Purchased Raffles</span>
                    </Link>
                  </div>
                )}
              </div>

              <div ><Link activeClass="" id="fontSize" to="" spy={true} smooth={true} duration={550}>Marketplace</Link></div>
            </div>

            <div class="logoDiv"><img onClick={() => window.location.href = '/'} src={logoPic} /></div>
            <div class="right">

              <div class="socialIcon">
                <img src={facebook} />
                <img src={instagram} />
                <img src={twitter} />
                <img src={whatsapp} />
              </div>

              {_connected ? (
                <button class="login" onClick={() => disconnectWallet()}>
                  {walletAddress === "" ? "Connect" : shortenAddress(walletAddress)}
                </button>
              ) : (
                <button class="login" onClick={() => { open(); }}>Connect</button>
              )}

            </div>

          </div>

        </div>

        {_navbarOpen > 0 ?
          (<div class="littleNav">
            <div class="connect">
              <div ><Link activeClass="" id="fontSize" onClick={() => window.location.href = 'raffles'}><span className='onNav'>Raffles</span></Link></div>
              <div className="dropdown-wrapper" ref={dropdownRef}>
                <Link
                  className="nav-link with-dropdown"
                  onClick={toggleDropdown}
                >
                  <span id="fontSize" className={showDropdown ? 'active' : ''}>My Raffles</span>
                  <svg
                    className={`dropdown-icon ${showDropdown ? 'rotate' : ''}`}
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                  >
                    <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </Link>

                {showDropdown && (
                  <div className="dropdown-menu">
                    <Link
                      className="dropdown-item"
                      onClick={() => window.location.href = 'my-raffles'}
                    >
                      Created Raffles
                    </Link>
                    <Link
                      className="dropdown-item"

                    >
                      <span className='active'>Purchased Raffles</span>
                    </Link>
                  </div>
                )}
              </div>
              <div ><Link activeClass="" id="fontSize" to="" spy={true} smooth={true} duration={550}>Marketplace</Link></div>
            </div>

            <div class="socialIcon">
              <img src={facebook} />
              <img src={instagram} />
              <img src={twitter} />
              <img src={whatsapp} />
            </div>

          </div>) : null}

        <div className="filter-controls">
          <button
            className={`filter-button ${filter === 'ongoing' ? 'active' : ''}`}
            onClick={() => setFilter('ongoing')}
          >
            Ongoing
          </button>
          <button
            className={`filter-button ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            All Purchases
          </button>
          <button
            className={`filter-button ${filter === 'ended' ? 'active' : ''}`}
            onClick={() => setFilter('ended')}
          >
            Ended
          </button>
        </div>

        {isLoadingPurchased ? (
          <div className='noR'>
            <div>Loading your purchases...</div>
          </div>
        ) : purchasedRaffles.length === 0 ? (
          <div className='noR'>
            <img src={ticketR} />
            <div>You haven't purchased any raffle tickets yet</div>
          </div>

        ) : filteredRaffles.length === 0 ? (
          <div className='noR'>
            <img src={ticketR} />
            <div>
              {filter === 'all' && "No raffles found in your purchases"}
              {filter === 'ongoing' && "No ongoing raffles found in your purchases"}
              {filter === 'ended' && "No ended raffles found in your purchases"}
            </div>
          </div>

        ) : (
          <>
            <div className='raffleSection'>
              {purchasedRaffles
                .filter(raffle => {
                  const now = Date.now() / 1000;
                  const isEnded = raffle.endTime < now;

                  if (filter === 'all') return true;
                  if (filter === 'ongoing') return !isEnded;
                  if (filter === 'ended') return isEnded;
                  return true;
                })

                .map((raffle, index) => (
                  <div className='raffleSection2' key={index}>
                    <div className={`raffleBox ${raffle.isStopped ? 'ended' : ''}`}
                      onClick={() => navigate(`/raffle/${raffle.id}`, { state: { raffle } })}>
                      {raffle.isStopped && (
                        <div className="ended-banner">Ended</div>
                      )}
                      <div className='mainRIDiv'>
                        <img className='mainRI' src={raffle.imageUrl} alt={raffle.name} />
                      </div>
                      <div className='raffleCon'>
                        <div>
                          <div className='amount'>{raffle.ticketPrice / 10 ** 18}<img src={coin} /></div>
                          <div className='tickets'>
                            <img src={ticket} />
                            <div>
                              <div>Total spent: {formatEther(raffle.totalSpent)} POL</div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div className='raffleCon'>
                        <div className='amountCon'>{raffle.name}<br />{raffle.tagline}</div>
                      </div>

                      {/* Add refund eligibility check */}
                      {raffle.isStopped && !raffle.isWinner && !raffle.isRefunded && (
                        <div className="refund-eligibility">
                          {raffle.totalTicketsIssued < (expectedValues[raffle.id] * 0.8) ? (
                            <button
                              className="refund-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleClaimRefund(raffle.id);
                              }}
                            >
                              Claim Refund
                            </button>
                          ) : (
                            <div className="refund-notice">Not eligible for refund</div>
                          )}
                        </div>
                      )}

                      {raffle.isWinner && (
                        <div className="winner-banner">🏆 You Won!</div>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </>
        )}

      </div >
      <img className='line2' src={line3} />

      <Footer />

    </div >
  )

}
export default MyInvestment;
